import { ExtendedWindow, WidgetInstance, WidgetState, createWidget } from '@livechat/widget-core';
import { memo, useEffect, useRef } from 'react';

declare const window: ExtendedWindow;
interface Props {
    license: string;
    visibility?: WidgetState['visibility'];
    onShowChat: boolean;
}
function LiveChatWidget(props: Props) {
    const widgetRef = useRef<WidgetInstance | null>(null);
    useEffect(() => {
        widgetRef.current = createWidget(props);
        window.__lc.integration_name = process.env.PACKAGE_NAME;
        widgetRef.current.init();
        if (props.onShowChat) {
            widgetRef.current?.updateVisibility('maximized');
        } else {
            widgetRef.current?.updateVisibility('minimized');
        }
    });
    return (
        <>
            <span>
                Quên mật khẩu hoặc <br></br> tên đăng nhập?
            </span>
        </>
    );
}

export default memo(LiveChatWidget);
